"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __importDefault(require("vue"));
var RadioInput_vue_1 = __importDefault(require("./RadioInput.vue"));
var vue_select_1 = __importDefault(require("vue-select"));
var vue_image_upload_resize_1 = __importDefault(require("vue-image-upload-resize"));
var debounce_1 = require("debounce");
var Models_1 = require("../Models");
var Parcelle_vue_1 = __importDefault(require("./Parcelle.vue"));
var Acteur_vue_1 = __importDefault(require("./Acteur.vue"));
var Enums_1 = require("../Enums");
var GeneratedConvention_vue_1 = __importDefault(require("./GeneratedConvention.vue"));
var CheckboxInput_vue_1 = __importDefault(require("./CheckboxInput.vue"));
var NumberInput_vue_1 = __importDefault(require("./NumberInput.vue"));
var TextInput_vue_1 = __importDefault(require("./TextInput.vue"));
var MultilineTextInput_vue_1 = __importDefault(require("./MultilineTextInput.vue"));
var SelectInput_vue_1 = __importDefault(require("./SelectInput.vue"));
exports.default = vue_1.default.extend({
    components: {
        MultilineTextInput: MultilineTextInput_vue_1.default,
        NumberInput: NumberInput_vue_1.default,
        TextInput: TextInput_vue_1.default,
        CheckboxInput: CheckboxInput_vue_1.default,
        GeneratedConvention: GeneratedConvention_vue_1.default,
        Acteur: Acteur_vue_1.default,
        Parcelle: Parcelle_vue_1.default,
        RadioInput: RadioInput_vue_1.default,
        SelectInput: SelectInput_vue_1.default,
        vSelect: vue_select_1.default,
        vueImageUploadResize: vue_image_upload_resize_1.default,
    },
    props: {
        model: {
            type: Object,
        }
    },
    watch: {
        "data.NbSupports": function (v) {
            this.data.DimensionsMassifs.length = v;
            for (var i = 0; i < v; i++) {
                if (this.data.DimensionsMassifs[i] === undefined) {
                    this.data.DimensionsMassifs[i] = {
                        Longueur: "",
                        Largeur: "",
                    };
                }
            }
        }
    },
    data: function () {
        var data = this.model && this.model.Data || new Models_1.ConventionServitude;
        var commune = data.Commune || new Models_1.Commune;
        data.Parcelles = data.Parcelles || [];
        data.Beneficiaire = data.Beneficiaire || new Models_1.Acteur;
        data.GeneratedConventions = data.GeneratedConventions || [];
        if (data.Parcelles.length === 0) {
            data.Parcelles.push(new Models_1.Parcelle(commune));
        }
        return {
            // Enums
            TypeOuvrage: Enums_1.TypeOuvrage,
            TypeReseau: Enums_1.TypeReseau,
            optionsActionRepriseBranchementElec: Object.values(Enums_1.RepriseBranchementElecActionEnum),
            optionsActionRepriseBranchementIce: Object.values(Enums_1.RepriseBranchementIceActionEnum),
            id: this.model.Id,
            numero: this.model.Numero,
            statut: this.model.StatutLabel,
            data: data,
            communesOptions: [],
            conventionsOptions: [],
            processing: false,
            error: false,
        };
    },
    mounted: function () {
        if (this.data.PhotoDataUri && this.$refs.photoUpload) {
            this.$refs.photoUpload.imagePreview = this.data.PhotoDataUri;
        }
        this.updateConventionsList();
    },
    methods: {
        fetchCommunes: debounce_1.debounce(function (search, loading) {
            var _this = this;
            loading(true);
            $.ajax({
                url: '/Cadastre/SearchCommune',
                data: {
                    keywords: search
                },
            }).done(function (d) {
                loading(false);
                return _this.communesOptions = d;
            });
        }, 500),
        appendParcelle: function () {
            this.data.Parcelles.push(new Models_1.Parcelle(this.data.Commune));
        },
        removeParcelle: function (i) {
            this.data.Parcelles.splice(i, 1);
        },
        removeProprietaire: function (proprietaire) {
            for (var _i = 0, _a = this.data.Parcelles; _i < _a.length; _i++) {
                var parcelle = _a[_i];
                parcelle.Proprietaires = parcelle.Proprietaires.filter(function (_) { return !proprietaire.Identifier || _.References !== proprietaire.Identifier; });
            }
        },
        updateConventionsList: debounce_1.debounce(function () {
            var _this = this;
            $.ajax({
                url: "/Affaires/FindTypesConventionServitude",
                type: 'post',
                dataType: 'json',
                contentType: 'application/json',
                data: JSON.stringify(this.data),
            }).done(function (d) {
                if (d.length === 0) {
                    _this.conventionsOptions = null;
                }
                _this.conventionsOptions = d;
            });
        }, 300),
        submitConvention: function ($event) {
            var _this = this;
            $event.preventDefault();
            var $form = $($event.target);
            if (!$form.valid()) {
                return;
            }
            this.processing = true;
            var creating = this.id == 0;
            var $button = $($event.submitter);
            var formaction = $button.attr("formaction");
            var url = formaction || (creating ? '/Affaires/CreateConventionServitude' : '/Affaires/UpdateConventionServitude');
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                contentType: 'application/json',
                data: JSON.stringify({
                    Id: this.id,
                    Data: this.data,
                    AffaireId: this.model.AffaireId
                }),
            }).done(function (d) {
                _this.processing = false;
                _this.error = !!d.error;
                if (creating) {
                    document.location.href = "/Affaires/EditConventionServitude/" + d.Id;
                    return;
                }
                if (formaction) {
                    document.location.href = "/Affaires/ConventionsServitude/" + d.AffaireId;
                    return;
                }
                _this.data = d.Data;
                _this.id = d.Id;
                _this.numero = d.Numero;
            });
        },
        generateConvention: function (proprietaires, parcelles) {
            var conv = new Models_1.GeneratedConvention();
            conv.Parcelles = parcelles.map(function (_) { return _.Identifier; });
            conv.Proprietaires = proprietaires.map(function (_) { return _.Identifier; });
            if (this.conventionsOptions.length == 1) {
                conv.TypeConvention = this.conventionsOptions[0].Id;
            }
            return conv;
        },
        autoSelect: function () {
            var generatedConventions = [];
            var parcellesHashSet = {};
            // On regroupe les parcelles par leur liste de propriétaires, si elle est identique on les met dans le même groupe
            for (var _i = 0, _a = this.data.Parcelles; _i < _a.length; _i++) {
                var parcelle = _a[_i];
                if (parcelle.Proprietaires.length === 0) {
                    continue;
                }
                var hash = parcelle.Proprietaires.map(function (_) { return _.Identifier || _.References; }).sort().join(',');
                if (!(hash in parcellesHashSet)) {
                    parcellesHashSet[hash] = [];
                }
                parcellesHashSet[hash].push(parcelle);
            }
            var indivSimple = Enums_1.TypeDroitProprieteEnum.IndivisionSimple.value;
            // Pour chaque groupe on prépare une convention qui contient les parcelles du groupe et les propriétaires du groupe 
            // (qui sont censés être les mêmes sur toutes les parcelles du groupe)
            for (var _b = 0, _c = Object.values(parcellesHashSet); _b < _c.length; _b++) {
                var parcelles = _c[_b];
                var proprietaires = parcelles[0].Proprietaires;
                // Indivision simple : une seule convention
                if (proprietaires.length === 2
                    && proprietaires[0].RegimePropriete === indivSimple
                    && proprietaires[1].RegimePropriete === indivSimple) {
                    var conv = this.generateConvention(proprietaires, parcelles);
                    generatedConventions.push(conv);
                }
                // Sinon : une convention par propriétaire, avec la liste de tous les proprietaires, mais chacun un premier tout à tour
                else {
                    var _loop_1 = function (prop) {
                        var proprietairesConvention = (_a = [prop]).concat.apply(_a, (proprietaires.filter(function (p) { return p.Identifier !== prop.Identifier; })));
                        var conv = this_1.generateConvention(proprietairesConvention, parcelles);
                        generatedConventions.push(conv);
                        var _a;
                    };
                    var this_1 = this;
                    for (var _d = 0, proprietaires_1 = proprietaires; _d < proprietaires_1.length; _d++) {
                        var prop = proprietaires_1[_d];
                        _loop_1(prop);
                    }
                }
            }
            this.data.GeneratedConventions = generatedConventions;
        },
        getProprietaires: function () {
            var proprietaires = [];
            var parcelles = this.data.Parcelles;
            for (var _i = 0, parcelles_1 = parcelles; _i < parcelles_1.length; _i++) {
                var parcelle = parcelles_1[_i];
                proprietaires.push.apply(proprietaires, parcelle.Proprietaires);
            }
            return proprietaires;
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./_wwwsrc/js/ConventionServitude/Components/ConventionServitude.vue
// module id = 227
// module chunks = 0